// extracted by mini-css-extract-plugin
export var articleHead = "ArticleHead-module--articleHead--3hfWR";
export var titleWrapper = "ArticleHead-module--titleWrapper--2zC3F";
export var category = "ArticleHead-module--category--3zK9D";
export var title = "ArticleHead-module--title--3vS3l";
export var lead = "ArticleHead-module--lead--1STwN";
export var authorSection = "ArticleHead-module--authorSection--iEUqw";
export var authorPic = "ArticleHead-module--authorPic--49epe";
export var authorName = "ArticleHead-module--authorName--z29fJ";
export var timeToRead = "ArticleHead-module--timeToRead--1TOss";